var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"certificate-pointer"},[_c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
      content: ("" + (_vm.certificate.name)),
      placement: 'top-center',
    }),expression:"{\n      content: `${certificate.name}`,\n      placement: 'top-center',\n    }"}],staticClass:"certificate-pointer__icon-wrapper",style:(("--learning-area-color: " + _vm.color))},[_c('CertificateIcon')],1),_c('span',[_vm._v(_vm._s(_vm.certificate.short_name))])])}
var staticRenderFns = []

export { render, staticRenderFns }